import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { BaseComponent } from '../../base-components/base.component';
import { DocumentData } from '../../models/document/document-data.model';
import { DocumentItemKeyData } from '../../models/document/document-itemkey.model';

export class DocumentLaunchContext {
    constructor(public documentItemKeyCollection: DocumentItemKeyData[], public customerNumberId?: number) {}
}

@Component({
    selector: 'document-launch-modal',
    templateUrl: './document-launch-modal.html'
})
export class DocumentLaunchModalComponent extends BaseComponent {
    context: DocumentLaunchContext;
    public documentItemKeyCollection: DocumentItemKeyData[] = new Array<DocumentItemKeyData>();
    public dataLoaded = false;
    public documentsSaved: DocumentData[] = [];
    public customerNumberId: number;

    constructor(public dialogRef: MatDialogRef<DocumentLaunchModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: DocumentLaunchContext) {
        super();
    }

    public ngOnInit() {
        for (let i = 0; i < this.data.documentItemKeyCollection.length; i++) {
            const documentItemKeyData = new DocumentItemKeyData();
            documentItemKeyData.documentItemKeyTypeId = this.data.documentItemKeyCollection[i].documentItemKeyTypeId;
            documentItemKeyData.itemKeyId = this.data.documentItemKeyCollection[i].itemKeyId;
            this.documentItemKeyCollection.push(documentItemKeyData);
        }
        this.dataLoaded = true;

        if (this.data.customerNumberId > 0) {
            this.customerNumberId = this.data.customerNumberId;
        }
    }

    public cancel() {
        this.dialogRef.close(this.documentsSaved);
    }
}
